// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZymNy","right":"styles_right__2W-v1"};